// Central config — brand tokens, map basemap, and type styling.

// Backend Worker. Dev points at local `wrangler dev`; prod at the deployed
// Worker (set the real URL — e.g. https://paris-eater-map.<you>.workers.dev —
// or a custom route like https://api.map.pariseater.com before launch).
export const WORKER_URL = import.meta.env.DEV
  ? 'http://127.0.0.1:8787'
  : 'https://paris-eater-map-api.richard-0bc.workers.dev'

// Paddle checkout (Billing). Fill these from the Paddle dashboard:
//   token   — Developer Tools → Authentication → Client-side token (publishable)
//   priceId — the $39 one-time price (pri_...)
//   env     — 'sandbox' while testing, 'production' for live
// When token/priceId are empty, the unlock button falls back to the restore
// flow so the app still works before Paddle is wired.
export const PADDLE = {
  token: 'live_426ed3d70a2e8a1f0a5a29e5b9d',
  priceId: 'pri_01kvrpr6rdp1jyds520evegyz8',
  env: 'production',
}

export const PRICE = '$39'

// Paris Eater redesign tokens (Fraunces/Inter, terracotta + ink).
export const BRAND = {
  cream: '#f7f4ee',
  paper: '#fffdf9',
  ink: '#1c1a17',
  inkSoft: '#56504a',
  line: '#e4ded3',
  accent: '#b1442f', // terracotta
  accentSoft: '#c9745f',
  grey: '#b6afa4',
}

// Pin colour per venue type — terracotta restaurants, ink bars (brief);
// cafés/bakeries get complementary editorial tones.
export const TYPE_COLOR = {
  restaurant: BRAND.accent,
  bar: BRAND.ink,
  cafe: '#c98a2b',
  bakery: '#5a7d6f',
  shop: '#7d5a86', // specialty food shops (charcuteries, cheese shops)
}

export const TYPE_LABEL = {
  restaurant: 'Restaurants',
  bar: 'Bars',
  cafe: 'Cafés',
  bakery: 'Bakeries',
  shop: 'Shops',
}

export const PRICE_LABEL = { 1: '€', 2: '€€', 3: '€€€', 4: '€€€€' }
export const PRICE_WORD = { 1: 'Budget', 2: 'Mid-range', 3: 'Higher-end', 4: 'Top-end' }

// Paris centre + sensible bounds
export const MAP = {
  center: [2.3475, 48.8566],
  zoom: 12.2,
  minZoom: 10,
  maxBounds: [[2.18, 48.78], [2.52, 48.94]],
}

// Basemap style.
//   DEV: OpenFreeMap "positron" — free, no API key, light/minimal (guidebook feel).
//   PROD: swap to self-hosted Protomaps PMTiles on Cloudflare R2 (see Phase 4).
//         Never use tile.openstreetmap.org (usage policy forbids commercial use).
export const BASEMAP_STYLE = 'https://tiles.openfreemap.org/styles/positron'

// When ready, replace the line above with the PMTiles style — example:
//   import { Protocol } from 'pmtiles'
//   maplibregl.addProtocol('pmtiles', new Protocol().tile)
//   style = { ...protomapsLight, sources: { protomaps: { type: 'vector',
//     url: 'pmtiles://https://<your-r2-domain>/paris.pmtiles' } } }
